export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatSmsDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDate2 = (date) => {
  // تنسيق التاريخ باللغة العربية
  const arabicDate = new Date(date).toLocaleDateString("ar-EG", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // تحويل الأرقام من العربية إلى الإنجليزية
  const arabicToEnglishDigits = (str) => {
    return str.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (match) =>
      String.fromCharCode(match.charCodeAt(0) - 1632 + 48)
    );
  };

  return arabicToEnglishDigits(arabicDate);
};

// New function to format date and time with AM/PM
export const formatDateTimeWithAMPM = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  
  // Convert to 12-hour format with AM/PM
  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${amPm}`;
};

// New function to format time only with AM/PM
export const formatTimeWithAMPM = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  
  // Convert to 12-hour format with AM/PM
  const amPm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
  
  return `${hours}:${minutes}:${seconds} ${amPm}`;
};

// New function to format date and time with AM/PM using toLocaleString
export const formatDateTimeLocaleWithAMPM = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  
  return date.toLocaleDateString("en-GB", options);
};